import React, { useState, lazy, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Filters from './Filters';
import { useHistory } from 'react-router-dom';
import { isInsuracePortalUser, getQueryStringKeys } from 'globalutils/fmUtils';
import { periodList } from 'globalconfig/constants/keys';
import BarGraph from './Graphs/BarGraph';
import PieGraph from './Graphs/PieGraph';
import ScatterPlot from './Graphs/ScatterPlot';
import moment from 'moment';
import { getConfig, monthVals } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  paginateList,
  chartsData,
  hasFetchApiStatus,
  Styled,
  i18n,
  changeRequest,
  request,
  pagination,
  setPagination,
  companyId,
  downloadDocument,
  callback,
  vehicles
}) => {
  const history = useHistory();
  const queryPeriod = getQueryStringKeys(history.location.search, 'period');

  const [values, setInitialValues] = useState({
    period: periodList.filter((ele) => ele.value == queryPeriod)[0],
    behavior: null,
    severity: null,
    vehicleId: null
  });
  const insuracePortalUserRole = isInsuracePortalUser();

  const columns = useMemo(() => {
    return getConfig({ i18n, insuracePortalUserRole }).tableColumns;
  }, []);

  const generateRows = () => {
    return paginateList.content || [];
  };

  const information = hasFetchApiStatus?.errorMessage ? (
    <Message type="error" message={hasFetchApiStatus.errorMessage} />
  ) : (
    'common.tableEmptyMessage'
  );
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabValues = [
    {
      name: i18n.t('Bar Graph'),
      value: (
        <BarGraph
          period={request.period || queryPeriod}
          data={chartsData.barChartList || []}
        />
      )
    },
    {
      name: i18n.t('Pie Chart'),
      value: <PieGraph data={chartsData.pieChartList || []} />
    },
    {
      name: i18n.t('Scatterplot'),
      value: <ScatterPlot data={chartsData.scatterPlotList} />
    }
  ];

  const getMonth = () =>
    (request.period || queryPeriod) === 'MONTHLY'
      ? monthVals[new Date().getMonth()]
      : '01';

  const getVehicleList = () => {
    if (!vehicles?.vehicleList) return [];

    return vehicles.vehicleList
      .filter((ele) => !insuracePortalUserRole || ele.companyId == companyId)
      .map(({ unit_id, id }) => ({ label: unit_id, value: id }));
  };

  return (
    <Styled.Wrapper>
      <div className="quickFilter"></div>
      <div className="tableWrapper">
        <div className="filterWrapper">
          <Filters
            filterList={(data) => {
              setPagination(true);
              changeRequest({
                ...data,
                displayLength: '10',
                displayStart: '1'
              });
            }}
            vehicleList={getVehicleList()}
            handleReset={() => {
              changeRequest({
                period: queryPeriod,
                behavior: null,
                severity: null,
                vehicleId: null,
                displayLength: '10',
                displayStart: '1'
              });
            }}
            history={history}
            values={values}
            setInitialValues={setInitialValues}
          />
          <Button
            type="submit"
            label={i18n.t('Download Report')}
            onClick={() => {
              downloadDocument({
                apiId: 'scoreCardReportDownload',
                callback,
                data: {
                  companyIds: [companyId],
                  type: 'SCORE_CARD',
                  endDate: moment(new Date()).format('MM/DD/YYYY'),
                  startDate: `${getMonth()}/01/${new Date().getFullYear()}`
                }
              });
            }}
          />
        </div>

        <div className="pageWrapper">
          <div>
            <Table
              type="server"
              changeRequest={changeRequest}
              baseRequest={request}
              defaultSortBy={{ sortBy: 'behaviour', order: 'desc' }}
              title=""
              totalRecords={paginateList?.totalElements || 0}
              columns={[...columns]}
              data={generateRows()}
              emptyMessage={information}
              itemsPerPage={10}
              pageinationReset={pagination}
              actions={[]}
              i18n={i18n}
              pagenationClicked={(e) => {
                setPagination(!e);
              }}
            />
          </div>
          <div className="graphWrapper">
            <Tab
              data={tabValues}
              currentTab={value}
              onChange={handleChange}
              className="graphTabs"
            />
          </div>
        </div>
      </div>
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  list: PropTypes.array.isRequired,
  hasFetchApiStatus: PropTypes.object.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.array.isRequired
};
